import translations from './translations'

translations.add('is', {
    description: 'Vinsamlegast hafðu samband við söluaðila til að leysa þetta vandamál',
    close: 'LOKA'
})
